import React, { useState } from "react";
import { ProductCard } from "./ProductCard";
import { Reveal } from "./Reveal";

// 12 = podzielne przez 2/3/4 kolumny siatki na wszystkich breakpointach —
// domyślny widok ma zawsze pełne rzędy, bez samotnego produktu na końcu.
const INITIAL_COUNT = 12;

export function ProductGrid({ products, testid = "product-grid", cols = "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" }) {
  const [showAll, setShowAll] = useState(false);
  if (!products.length) return null;
  const shown = showAll ? products : products.slice(0, INITIAL_COUNT);

  return (
    <>
      <div className={`grid gap-4 sm:gap-6 ${cols}`} data-testid={testid}>
        {shown.map((p, i) => (
          <Reveal key={p.id} delay={Math.min(i, 8) * 70}>
            <ProductCard product={p} />
          </Reveal>
        ))}
      </div>
      {products.length > INITIAL_COUNT && (
        <div className="mt-10 text-center">
          <button
            data-testid={`${testid}-show-more`}
            onClick={() => setShowAll(!showAll)}
            className="rounded-full border border-cyan-400/40 bg-cyan-400/10 px-8 py-3 font-display text-sm font-bold text-cyan-200 transition-all hover:scale-105 hover:bg-cyan-400/20 active:scale-95"
          >
            {showAll ? "Pokaż mniej" : `Pokaż wszystkie (${products.length})`}
          </button>
        </div>
      )}
    </>
  );
}
